<template>
  <div>
    <b-modal
      :id="`add-drop-zones-${service}`"
      ok-only
      ok-title="Done"
      centered
      title="Add Drop Zones"
      ok-variant="success"
      @ok="addDropZones"
    >
      <b-row
        v-for="(_, key, i) in zones"
        :key="i"
        class="mb-1"
      >
        <b-col
          class="d-flex align-items-center"
          md="6"
        >
          <span>{{ key.split('::')[1] }}</span>

        </b-col>
        <b-col md="6">
          <b-form-input
            v-model.number="zonesValues[key]"
            type="number"
          />
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import {
  BModal, BFormInput, BRow, BCol,
} from 'bootstrap-vue'
import { ref } from '@vue/composition-api'

export default {
  components: {
    BModal,
    BFormInput,
    BRow,
    BCol,
  },
  props: {
    service: {
      type: String,
      required: true,
    },
    zones: {
      type: Object,
      default: () => ({}),
    },
    selectedDropZones: {
      type: Object,
      default: () => ({}),
    },
  },
  setup(props, { emit }) {
    const zonesValues = ref({ ...props.selectedDropZones })
    const addDropZones = () => {
      emit('drop-zones', zonesValues)
    }
    return {
      addDropZones,
      zonesValues,
    }
  },
}
</script>
